import { cn } from '@/lib/cn';

type LogoProps = {
  className?: string;
  width?: number;
};

export function LogoMark({ className, width = 30 }: LogoProps) {
  return (
    <svg
      width={width}
      height={(width / 3) * 2}
      viewBox="0 0 30 20"
      fill="none"
      aria-hidden
      className={cn('shrink-0', className)}
    >
      <path
        d="M0 2C11 2 12 10 20 10M0 10H20M0 18C11 18 12 10 20 10"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path d="M20 10H30" stroke="var(--color-accent)" strokeWidth={2} />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-3 text-xl font-medium tracking-[-0.02em]',
        className,
      )}
    >
      <LogoMark />
      Fincrex
    </span>
  );
}
